import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Callout } from '../../molecules';
export const CalloutStatementsError = memo(({ onRetry }) => {
    return (_jsx(Callout, { icon: "Lock", title: "Ooops, something\u2019s up!", message: "Just a small error, no need to panic. Navigate back Home or try again.", variant: "secondary", contained: true, small: true, ctas: [
            {
                variant: 'secondary',
                label: 'Try again',
                onPress: onRetry,
                size: 'base',
                style: { minWidth: 130 },
            },
        ] }));
});
